var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8672 1.5C13.6628 1.5 14.4259 1.83466 14.9885 2.43037C15.5511 3.02607 15.8672 3.83402 15.8672 4.67647H18.8672C19.3976 4.67647 19.9063 4.89958 20.2814 5.29672C20.6565 5.69385 20.8672 6.23248 20.8672 6.79412V17.3824C20.8672 17.944 20.6565 18.4826 20.2814 18.8798C19.9063 19.2769 19.3976 19.5 18.8672 19.5H2.86719C2.33675 19.5 1.82805 19.2769 1.45297 18.8798C1.0779 18.4826 0.867188 17.944 0.867188 17.3824V6.79412C0.867187 6.23248 1.0779 5.69385 1.45297 5.29672C1.82805 4.89958 2.33675 4.67647 2.86719 4.67647H5.86719C5.86719 3.83402 6.18326 3.02607 6.74587 2.43037C7.30848 1.83466 8.07154 1.5 8.86719 1.5H12.8672ZM13.8672 6.79412H7.86719V17.3824H13.8672V6.79412ZM18.8672 6.79412H15.8672V17.3824H18.8672V6.79412ZM5.86719 6.79412H2.86719V17.3824H5.86719V6.79412ZM12.8672 3.61765H8.86719C8.62225 3.61768 8.38585 3.71289 8.20282 3.88523C8.01978 4.05756 7.90284 4.29503 7.87419 4.55259L7.86719 4.67647H13.8672C13.8672 4.41713 13.7772 4.16682 13.6145 3.97302C13.4517 3.77922 13.2274 3.6554 12.9842 3.62506L12.8672 3.61765Z",
    fill: "#58486C",
    stroke: "white",
    strokeWidth: 0.9375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.c3b7769829c8876444f3a4d87c39b6fa.svg";
export { ForwardRef as ReactComponent };